import queryParser from 'query-string';

export default class QueryStrUtil {
  updateCallbackValid = (param) => {
    const splited = param.split('?');
    let uriStr = '';
    for (let i = 0; i < splited.length; i++) {
      uriStr += splited[i];
      if (i === 0) {
        uriStr += '?';
        continue;
      }
      if (splited.length - 1 === i) {
        return uriStr;
      }
      uriStr += '&';
    }
  }
  getParamContent(param) {
    const value = queryParser.parse(window.location.search)[param];
    if (value === undefined) return '';
    return param === 'callback' ? this.encodeCallback(value) : value;
  }
  get parsedQuery() {
    return queryParser.parse(window.location.search);
  }
  encodeCallback(uri) {
    // URI 中に callback が含まれていた場合はURIエンコードする
    if (uri.match(/\?callback=/)) {
      const splited = uri.split('?callback=');
      return splited[0] + '?callback=' + encodeURIComponent(splited[1]);
    } else {
      return uri;
    }
  }
  checkUri(uri) {
    const l = document.createElement('a');
    l.href = uri;
    return ((l.hostname.match(/^.+\.energymntr\.com/)) || (l.hostname.match(/^localhost/))) // hostの確認
            && (l.protocol.match(/^https?:/)); // protocolの確認
  }
  hrefUrl(queries, uri) {
    if (!this.checkUri(uri)) {
      // マイページのルート (ログイン画面)
      return '/';
    }
    let parsedStr = {};
    for (let key in queries) {
      parsedStr[key] = queries[key];
    }
    const paramStr = uri + '?' + queryParser.stringify(parsedStr);
    return this.updateCallbackValid(paramStr);
  }
}
